import router from '@/router';
import http from '@/http';
import i18n from '@/i18n';

import AuthService from '@/services/auth';

import { snakeCase } from 'lodash';
import { Message, Notice } from 'iview';

function devErrorStatus(error) {
  Notice.error({
    title: `${error.response.status}`,
    duration: 5,
    render: h => h('div', null, [
      h('p', null, error.response.statusText),
      h('p', null, error.response.data.status),
      h('p', null, error.response.data.error),
      h('p', null, error.response.data.exception),
      h('p', null, error.message),
      h('p', null, error.stack),
    ]),
  });
}

function devErrorCode(error) {
  Notice.error({
    title: error.message,
    dangerouslyUseHTMLString: true,
    desc: error.stack,
    duration: 5,
  });
}

AuthService.$on('unauthorized', () => {
  router.push({ name: 'login', query: { redirect: router.currentRoute.fullPath } });
});

http.interceptors.response.use(undefined, (error) => {
  if (http.isCancel(error)) {
    // canceled request
  } else if (error.response) {
    switch (error.response.status) {
      case 401:
        // AuthService
        break;
      case 422:
        break;
      case 400:
      case 404:
      case 409:
      case 500:
      default:
        Message.error({
          content: i18n.te(`errors.server.${error.response.status}`) ?
            i18n.t(`errors.server.${error.response.status}`) :
            i18n.t('errors.server.default'),
          duration: 10,
          closable: true,
        });
        if (process.env.NODE_ENV !== 'production') devErrorStatus(error);
        break;
    }
  } else {
    const message = snakeCase(error.message);
    Message.error({
      content: i18n.te(`errors.app.${message}`) ?
        i18n.t(`errors.app.${message}`) :
        i18n.t('errors.default'),
      duration: 10,
      closable: true,
    });
    if (process.env.NODE_ENV !== 'production') devErrorCode(error);
  }
  return Promise.reject(error);
});
